import ChartTooltip from 'components/molecules/chartTooltip';
import React from 'react';
import {View} from 'react-native';
import {
  ResponsiveContainer,
  AreaChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Area,
} from 'recharts';
import {CategoricalChartState} from 'recharts/types/chart/generateCategoricalChart';
import {StudentType} from 'services/API/ClassApi/ClassApiModels';

interface AttentionChartProps {
  data: object[];
  colors: string[];
  onChartClick: (event: CategoricalChartState) => void;
  onAnimationEnd: () => void;
  students: StudentType[];
}

const AttentionChart = (props: AttentionChartProps) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        height={700}
        data={props.data}
        onClick={event => props.onChartClick(event)}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}>
        <defs>
          {Object.keys(props.data.length > 0 && props.data[0]).map(
            (item, index) => {
              return item === 'offset' ? (
                <View key={`${index + 1}`} />
              ) : (
                <linearGradient
                  id={item}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                  key={`${index} ${item}`}>
                  <stop
                    key={`first-${index + 1}`}
                    offset="5%"
                    stopColor={props.colors[index]}
                    stopOpacity={0.5}
                  />
                  <stop
                    key={`second-${index + 1}`}
                    offset="95%"
                    stopColor={props.colors[index]}
                    stopOpacity={0}
                  />
                </linearGradient>
              );
            },
          )}
        </defs>
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis dataKey="offset" />
        <YAxis tickCount={6} hide={true} />
        <Tooltip
          content={
            <ChartTooltip
              colors={props.colors}
              payload={[]}
              label={''}
              active={false}
              isShadow={true}
              students={props.students}
            />
          }
        />

        {Object.keys(props.data.length > 0 && props.data[0]).map(
          (item, index) => {
            return item === 'offset' ? (
              <View key={`${index + 1}`} />
            ) : (
              <Area
                animationDuration={4000}
                onAnimationEnd={() => props.onAnimationEnd()}
                key={`${index + 1} ${item}`}
                type="monotone"
                dataKey={item}
                stroke={props.colors[index]}
                fill={`url(#${item})`}
                fillOpacity={1}
              />
            );
          },
        )}
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default AttentionChart;
